<template>
	<div :class="`c-gallery-image-scroller ${controlsLiveRegion
		? 'c-gallery-image-scroller--controls-live-region'
		: ''
		}`
		">

		<div v-if="$resize && $mq.above(1024)"
			class="c-gallery-image-scroller__thumbnail-nav c-gallery-image-scroller__thumbnail-nav--left">
			<!--<button type="button" @click="showPrev" v-if="showLeftButton">
					<span class="t-visually-hidden">{{ scrollLeftText }}</span>
					<v-icon
						class="t-rotate--flip-hz"
						name="icon-chevron"
						size="xl"
					></v-icon>
				</button>-->
		</div>

		<div class="c-gallery-image-scroller__image-row" :class="{ 'has-intro': hasSlot }">

				<slot name="intro"></slot>

				<VueSlickCarousel v-bind="settings" ref="carousel" @reInit="onInitCarousel" @afterChange="afterChange">
					<v-object-development v-for="(image, index) in images" :key="index" :image="image"
						:readMoreLabel="readMoreLabel" :headingLevel="headingLevel" />

					<template #customPaging="page">
						<div class="c-gallery-image-scroller__pagination--dot">
							&nbsp;
						</div>
					</template>
				</VueSlickCarousel>

		</div>

		<div v-if="$resize && $mq.above(1024)"
			class="c-gallery-image-scroller__thumbnail-nav c-gallery-image-scroller__thumbnail-nav--right">
			<!--<button
					type="button"
					ref="buttonScrollRight"
					@click="showNext"
					v-if="showRightButton && images.length > 3"
				>
					<span class="t-visually-hidden">{{ scrollRightText }}</span>
					<v-icon name="icon-chevron" size="xl"></v-icon>
				</button>-->
		</div>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";
import VObjectDevelopment from "../../components/object-listing/object-development/VObjectDevelopment.vue";
import VueSlickCarousel from "vue-slick-carousel";

export default {
	name: "VGalleryImageScroller",
	components: {
		VIcon,
		VueSlickCarousel,
		VObjectDevelopment
	},
	props: {
		controlsLiveRegion: {
			type: Boolean,
			default: false
		},
		isLinks: {
			type: Boolean,
			default: false
		},
		hasTextBelow: {
			type: Boolean,
			default: false
		},
		showPagination: {
			type: Boolean,
			default: true
		},
		readMoreLabel: {
			type: String,
			default: "Läs mer"
		},
		images: {
			type: Array,
			default: () => []
		},
		thumbnailWidth: {
			type: Number,
			default: 21
		},
		stepLength: {
			type: Number,
			default: 1
		},
		scrollLeftText: {
			type: String,
			default: "Scrolla vänster"
		},
		scrollRightText: {
			type: String,
			default: "Scrolla höger"
		},
		minNumToShow: {
			type: String,
			default: "1"
		},
		headingLevel: {
			type: "h2" | "h3",
			default: "h2"
		}
	},
	data() {

		return {
			currentIndex: 0,
			scrollStep: 0,
			showNavRight: true,
			showAll: false,
			showLeftButton: false,
			showRightButton: true,
			settings: null
		};
	},
	computed: {
		hasSlot() {
			return this.$slots['intro'] && this.$slots['intro'].filter(vnode => vnode.type !== Comment && (vnode.type !== Text || vnode.children.trim() !== ''));
		},
		firstInView() {
			return this.scrollStep;
		},
		lastInView() {
			return Math.floor(
				this.scrollStep * this.stepLength + 100 / this.thumbnailWidth
			);
		}
	},
	methods: {
		showPrev() {
			this.$refs.carousel.prev();
		},
		showNext() {
			this.$refs.carousel.next();
		},
		afterChange(slideIndex) {
			this.showLeftButton =
				slideIndex > 0 && slideIndex < this.images.length - 1;
			this.showRightButton = slideIndex <= this.images.length - 4;
		},
		onInitCarousel() {
			const wrapper = document.querySelector('.c-gallery-image-scroller');

			if (wrapper) {
				const style = getComputedStyle(wrapper, null);
				const height = style.getPropertyValue('height');
				const slides = [...document.querySelectorAll('.slick-slider .slick-slide')];

				for (let i = 0; i < slides.length; i++) {
					slides[i].classList.add('c-gallery-image-scroller__item')
				}
			}

		}
	},
	mounted() {
		this.$nextTick(() => {
			let slickNexts = document.querySelectorAll("button.slick-next");
			slickNexts.forEach(i => {
				i.innerText = "Nästa";
				i.ariaLabel = "Nästa";
			});
			let slickPrevs = document.querySelectorAll("button.slick-prev");
			slickPrevs.forEach(i => {
				i.innerText = "Föregående";
				i.ariaLabel = "Föregående";
			})
		})
		this.settings = {
			slidesToScroll: 1,
			slidesToShow: this.hasSlot ? 2 : 3,
			initialSlide: 0,
			swipeToSlide: false,
			infinite: false,
			dots: this.showPagination,
			responsive: [
				{
					breakpoint: 499,
					settings: {
						dots: true,
						slidesToShow: 1
					}
				},
				{
					breakpoint: 1024,
					settings: {
						dots: true,
						slidesToShow: 1
					}
				}
			]
		};
	}
};
</script>
